import Page from '../../pages/page';
import { ajax } from '../../utils/ajaxHandler';
import { get, clone } from '../../utils/objectHelpers';
import LoadingSpinner from '../str-loading-spinner/component';

const SORT_LISTINGS_EVENT = 'sortListingsEvent';
const POPSTATE_UPDATE_EVENT = 'popstateUpdateEvent';
const AJAX_TIMEOUT = 10000;

export default class {
    onCreate(input, out) {
        this.defaultLanguage = get(out, 'global.req.locality.defaultLanguage');
        this.state = {
            page: input.page
        };
    }
    onMount() {
        document.addEventListener('ajax-module-update-event', evt => {
            this.updateModules({
                url: get(evt, 'detail.url'),
                updateEvent: get(evt, 'detail.updateEvent'),
                type: get(evt, 'detail.type'),
                spinnerId: get(evt, 'detail.spinnerId'),
                errorCallback: get(evt, 'detail.errorCallback')
            });
        });
        window.addEventListener('popstate', (evt) => {
            const updateEvent = evt.state && evt.state.updateEvent;
            if (updateEvent) {
                const spinnerId = getSpinnerId(updateEvent);
                LoadingSpinner.show(spinnerId);
                this.updateModules({
                    url: window.location.href,
                    updateEvent: POPSTATE_UPDATE_EVENT,
                    spinnerId: spinnerId
                });
            }
        });
    }
    updateModules(cfg) {
        // Show spinner
        let spinnerId = cfg.spinnerId;
        if (!spinnerId) {
            spinnerId = getSpinnerId(cfg.updateEvent);
        }
        LoadingSpinner.show(spinnerId);

        // Get and update content
        const ajaxUrl = buildAjaxUrl(cfg.url);
        ajax({ url: ajaxUrl }, {
            successCallBack: (resp) => {
                if (this.isError(resp)) {
                    if (cfg.errorCallback) {
                        cfg.errorCallback();
                    }
                } else {
                    const page = new Page(resp);
                    if (hasCategoryParam(cfg.url) && cfg.type === 'marketingBannerType') {
                        document.dispatchEvent(new CustomEvent('scroll-to-sticky-top'));
                    }
                    updateModulesAndPositions(this.state, page, cfg.url, cfg.updateEvent);
                }
                LoadingSpinner.hide(spinnerId);
            },
            errorCallBack: () => {
                if (cfg.errorCallback) {
                    cfg.errorCallback();
                }
                LoadingSpinner.hide(spinnerId);
            }
        },
        AJAX_TIMEOUT);
    }
    isError(resp) {
        return !!(!resp || resp.message || resp.stack); // Assumes resp.message and resp.stack are errors
    }
}

function buildAjaxUrl(url) {
    const link = document.createElement('a');
    link.href = url;
    let queryString;

    if (link.search) {
        queryString = `${link.search}&_ajax=itemFilter`;
    } else {
        queryString = `?_ajax=itemFilter`;
    }

    return `https://${window.location.host}${link.pathname}${queryString}`;
}

function hasCategoryParam(url) {
    return url.match(/_sacat=\d+|store_cat=\d+|_storecat=\d+/);
}

function updateModulesAndPositions(state, newPage, url, updateEvent) {
    const keys = Object.keys(get(newPage, 'modules'));
    if (keys.length) {
        const pageClone = clone(state.page);
        pageClone.modules = newPage.modules;
        const positionsReplaced = replaceTab0Positions(pageClone, newPage);
        if (positionsReplaced) {
            state.page = pageClone;
            updateWindowHistory(url, updateEvent);
        }
    }
}

function replaceTab0Positions(pageClone, newPage) {
    const listClone = get(pageClone, 'meta.pageTemplate.regions.TAB0.layouts.LIST_1_COLUMN');
    const newList = get(newPage, 'meta.pageTemplate.regions.TAB0.layouts.LIST_1_COLUMN');
    if (listClone && newList) {
        listClone.positions = newList.positions;
        return true;
    }
}

function updateWindowHistory(url, updateEvent) {
    if (url && updateEvent !== POPSTATE_UPDATE_EVENT) {
        try {
            const link = document.createElement('a');
            link.href = url;
            const newUrl = `https://${window.location.host}${link.pathname}${link.search}${window.location.hash}`;
            window.history.replaceState({ updateEvent: updateEvent }, '');
            window.history.pushState({ updateEvent: updateEvent }, '', newUrl);
        } catch (err) {
            // console.log(err);
        }
    }
}

function getSpinnerId(updateEvent) {
    let spinnerId = 'tab0LoadingSpinner';
    if (updateEvent === SORT_LISTINGS_EVENT) {
        spinnerId = 'listingsLoadingSpinner';
    }
    return spinnerId;
}
